export const HAS_ACCESS = 'HAS_ACCESS';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const IS_LOADING = 'IS_LOADING';
export const GET_DOMAIN = 'GET_DOMAIN';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_ROLES = 'GET_ROLES';
export const GET_USERS = 'GET_USERS';
export const GET_GAME_TYPES = 'GET_GAME_TYPES';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_COUNTRIES_LANGUAGES_SUBDOMAIN = 'GET_COUNTRIES_LANGUAGES_SUBDOMAIN';
export const OPEN_COUNTRY_DETAILS = 'OPEN_COUNTRY_DETAILS';
export const GET_GAMES = 'GET_GAMES';
export const GET_CATEGORY_DETAIL = 'GET_CATEGORY_DETAIL';
export const GET_GAME_DETAIL = 'GET_GAME_DETAIL';
export const GET_SIMILAR_GAMES = 'GET_SIMILAR_GAMES';
export const GET_SEARCHED_GAMES = 'GET_SEARCHED_GAMES';
export const GET_FAVOURITE_GAMES = 'GET_FAVOURITE_GAMES';
export const SET_FAVOURITE_GAME = 'SET_FAVOURITE_GAME';
export const HIDE_SPLASH = 'HIDE_SPLASH';
export const SHOW_SPLASH = 'SHOW_SPLASH';
export const ADD_UID = 'ADD_UID';
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
export const SHOW_SEARCH = 'SHOW_SEARCH';
export const GET_DETAILS = 'GET_DETAILS';
export const SET_DETAILS = 'SET_DETAILS';
export const GET_INTERESTS = 'GET_INTERESTS';
export const SET_PROFILE_PIC = 'SET_PROFILE_PIC';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const SEARCH_TEXT = 'SEARCH_TEXT';
export const CATEGORY_GAMES = 'CATEGORY_GAMES';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';



// WEBPACK FOOTER //
// ./src/actions/action_types.js